import {registerGraphNodeIn} from "@cm/graph-v3"

export const registerTemplateGraphNode = registerGraphNodeIn("template")
